<div class="hotel-page-container" [class]="themeService.getTheme()">
  <div class="hotel-page-background" [style]="background" [class]="backgroundClasses"></div>
  <div class="hotel-load-error" *ngIf="loadError" role="alert">
    <app-texts
      [texts]="[{text: ['Не удалось загрузить отель. Попробуйте ещё раз.', 'Unable to load the hotel. Please try again.']}]"/>
    <button type="button" (click)="retryHotel()">
      <app-texts [texts]="[{text: ['Повторить', 'Try again']}]"/>
    </button>
  </div>
  <div class="hotel-page-content" *ngIf="!loadError">
    <div class="hotel-page-workspace">
      <div class="mob-hotel-buttons" *ngIf="tab">
        <div class="mob-hotel-buttons-back" (click)="goBack()">
          <div class="mob-hotel-buttons-back-icon">
            <app-icon [icon]="Icons.hotelBackArrow"/>
          </div>
        </div>
        <div class="mob-hotel-buttons-link">
          <a target="_blank" [href]="this.hotel.link">
            <app-texts [texts]="[
                      {text: ['Обзор отеля', 'Hotel overview']}
                    ]"/>
          </a>
        </div>
      </div>
      <div class="hotel-page-workspace-content">
        <div class="hotel-page-workspace-title" *ngIf="!tab">
          <app-texts [texts]="hotelText"/>
        </div>
        <div class="hotel-page-workspace-subtitle" *ngIf="!tab">
          <a target="_blank" [href]="this.hotel.link">
            <app-texts [texts]="[
              {text: [hotel.titleRu + ' ', hotel.titleEn + ' '],},
          ]"/>
          </a>
        </div>
        <div class="hotel-page-workspace-subtitle" *ngIf="tab">
          <app-texts [texts]="[
              {text: [hotel.titleRu + ' ', hotel.titleEn + ' '],},
          ]"/>
        </div>
        <div class="hotel-page-workspace-title" *ngIf="tab">
          <a>
            <app-texts style="cursor: pointer" [texts]="hotelText"/>
          </a>
        </div>
        <div class="hotel-page-workspace-text">
          <app-texts [texts]="[
            {text: [
               this.hotel.descriptionRu,
               this.hotel.descriptionEn,
             ],
             transfer: true
            },
          ]"/>
        </div>
        <div class="hotel-page-workspace-buttons">
          <div class="d-flex flex-row align-items-center hotel-actions">
            <app-button (click)="emitClick()" [height]="tab ? 45 : 40">
              <h6 class="px-3 py-1">
                <app-texts [texts]="[
                  {text: ['Забронировать', 'Make request']}
                ]"/>
              </h6>
            </app-button>
            <a *ngIf="hotelArticle && !preview" class="hotel-article-link"
               [routerLink]="['/journal', hotelArticle.slug]">
              <app-texts [texts]="[{text: ['Читать статью', 'Read the story']}]"/>
            </a>
            <button *ngIf="!hotelArticle && !preview" class="hotel-article-link hotel-article-link-pending"
                    type="button" disabled>
              <app-texts
                [texts]="[{text: articleLoading ? ['Проверяем статью…', 'Checking for a story…'] : ['Статья скоро', 'Story coming soon']}]"/>
              <span aria-hidden="true">◷</span>
            </button>

            <div *ngIf="openWindow" class="hotel-window" @expandAnimation>
              <div class="hotel-window-head">
                <div class="hotel-window-head-title">
                  <app-texts [texts]="[
                      {text: ['Обзор отеля', 'Hotel overview']}
                    ]"/>
                </div>
                <div class="hotel-window-head-cross" (click)="openWindow = false">
                  <app-icon [icon]="Icons.cross"/>
                </div>
              </div>
              <div class="hotel-window-footer">
                <div class="hotel-window-footer-text col-8">
                  <app-texts [texts]="[
                      {text: [this.hotel.address ?? '', this.hotel.address ?? '']}
                    ]"/>
                </div>
                <div class="hotel-window-footer-button col-3">
                  <a target="_blank" [href]="this.hotel.link" class="hotel-window-footer-button-el">
                    <app-texts [texts]="[
                      {text: ['Найти', 'Discover']}
                    ]"/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hotel-page-location" *ngIf="interfaceService.getHotelOpenGeo()">
      <div class="hotel-page-location-text">
        {{ hotel.address }}
      </div>
      <div class="hotel-page-location-button">
        <a [href]="this.hotel.link">
          Discover
        </a>
      </div>
    </div>
  </div>
</div>
